import {
    DirectionsBoat as BoatIcon,
    Home as HouseIcon,
    Apartment as OfficeIcon,
    DirectionsCar as CarIcon,
    Celebration as BalloonIcon,
    Key as DefaultIcon,
} from '@mui/icons-material';

export const iconForType = (t?: string) => {
    const k = t?.toLowerCase?.();
    if (k === 'boat') return BoatIcon;
    if (k === 'property') return HouseIcon;
    if (k === 'commercial') return OfficeIcon;
    if (k === 'vehicle' || k === 'car') return CarIcon;
    if (k === 'activity') return BalloonIcon;
    return DefaultIcon;
};
